import { render } from "./BaseProgress.vue?vue&type=template&id=10452146"
import script from "./BaseProgress.vue?vue&type=script&lang=js"
export * from "./BaseProgress.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Centrion\\projetos\\vue-argon-centrion\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__